import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { Button, LinearProgress } from '@mui/material'
import { lessonScheduleApiSlice } from '../../../../features/schedule/lessonScheduleSlice'
import { H3 } from '../../../../layouts/TextStyles'
import LessonsTable from './components/LessonsTable'
import AddLessonDialog from './components/AddLessonDialog'
import { LessonScheduleState } from '../../../../features/types'
import { useParams } from 'react-router-dom'
import BaseBreadcrumb from '../../../../components/Breadcrumb'

const CourseSchedulePage = () => {
    const { courseId } = useParams()
    const { formatMessage } = useIntl()
    const [dialogOpen, setDialogOpen] = useState(false)
    const [editLesson, setEditLesson] = useState<LessonScheduleState | null>(null)

    const { data: lessons = [], isFetching } = lessonScheduleApiSlice.useFetchScheduleLessonsQuery(Number(courseId))
    const [deleteLesson, { isLoading: isDeleting }] = lessonScheduleApiSlice.useDeleteScheduleLessonMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteLesson(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {
            toast.error(formatMessage({ id: 'deleteFail' }))
        }
    }

    const handleOpenDialog = (lesson?: LessonScheduleState) => {
        setEditLesson(lesson || null)
        setDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setDialogOpen(false)
        setEditLesson(null)
    }

    return (
        <Wrapper>
            <BaseBreadcrumb links={[formatMessage({ id: 'schedule' })]} />
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'schedule' })}</H3>
                    </Title>
                    <Button variant="contained" onClick={() => handleOpenDialog()}>
                        {formatMessage({ id: 'add' })}
                    </Button>
                </Header>

                {isFetching || isDeleting ? (
                    <LinearProgress />
                ) : null}

                <LessonsTable
                    lessonsData={lessons}
                    onDelete={handleDelete}
                    onEdit={handleOpenDialog}
                />

                <AddLessonDialog
                    editLesson={editLesson || undefined}
                    open={dialogOpen}
                    handleClose={handleCloseDialog}
                />
            </Content>
        </Wrapper>
    )
}

export default CourseSchedulePage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
